import {Component, inject} from '@angular/core';
import {ModalContainerComponent} from '@layout/components/modals/modal-container/modal-container.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-logout-modal',
  templateUrl: './logout-modal.component.html',
  styleUrls: ['./logout-modal.component.scss'],
  imports: [
    ModalContainerComponent
  ]
})
export class LogoutModalComponent {
  private modalService = inject(NgbModal);

  closeModal() {
    this.modalService.dismissAll();
  }

  goToLoginModal() {
    this.modalService.dismissAll();
    import('../login-modal/login-modal.component').then(comp => {
      this.modalService.open(comp.LoginModalComponent);
    })
  }
}
